/* VitaFresh Newsletter-Fenster (Pasci 16.10.2026): ersetzt das Klaviyo-Popup und damit das Klaviyo-Onsite-Skript auf jeder Seite.
   Ob es in Frage kommt, entscheidet snippets/vf-newsletter.liquid (nur Gäste, nicht Warenkorb/Konto/Portal, nicht mit WELCOME15);
   dieses Skript lädt nur dann. Es öffnet nach VERZOEGERUNG_MS einmal ein <dialog> (Fokus, Esc und Hintergrund macht der Browser),
   CSS lädt erst kurz davor. Die Anmeldung geht direkt an Klaviyos öffentliche Anmelde-Schnittstelle (Client-API, Konto-ID ist
   öffentlich) in die Liste mit Double-Opt-in; Klaviyo schickt die Bestätigungs-Mail, danach läuft die Willkommensserie.
   Merker in localStorage «vfnl»: {zu: Zeitpunkt} nach Schliessen (RUHE_MS Ruhe), {dabei: 1} nach Anmeldung (nie mehr).
   «vfnl-kunde» setzt das Snippet für angemeldete Kunden (auch später als Gast nie). Ohne localStorage: Fenster je Seite höchstens
   einmal, nie ein Fehler. Reine Entscheidungen in «logik» (Node-Tests: tests/vf-newsletter.test.js).
   Wenig stören, aber gesehen werden (Pasci 21.10.2026, logik.entscheiden): nie beim ersten Seitenaufruf eines Besuchs (das
   Snippet zählt die Aufrufe in sessionStorage «vfnl-seiten»), nur auf Inhalts- und Kollektionsseiten (Startseite, Seiten, Blog,
   Kollektionen; nie Gericht, Warenkorb, Suche), nicht kurz nach «In den Warenkorb» (KORB_RUHE_MS, sessionStorage «vfnl-korb»,
   gesetzt vom Snippet auf jeder Seite, gilt also auch nach einem Kauf auf der Gericht-Seite), am Handy erst nach dem Scrollen. */
(function (root) {
  "use strict";

  var MERK = "vfnl";
  var KUNDE = "vfnl-kunde";
  var TAG_MS = 24 * 60 * 60 * 1000;
  var RUHE_MS = 30 * TAG_MS;           /* nach Schliessen 30 Tage Ruhe (Vault Systeme/Klaviyo, Pasci 06.10.2026) */
  var VERZOEGERUNG_MS = 12000;         /* 10–15 s nach dem Laden (ebenda) */
  var KORB_RUHE_MS = 2 * 60 * 1000;    /* nach «In den Warenkorb» 2 Minuten kein Fenster (Pasci 21.10.2026) */
  var GESCROLLT_PX = 150;              /* Handy: erst nach einem echten Stück Scrollen */
  var SEITEN = ["index", "page", "blog", "article", "collection", "list-collections"]; /* Inhalt und Kollektionen, nie Einkauf */
  var ZAEHLER = "vfnl-seiten";
  var KORB = "vfnl-korb";
  var NOCHMAL_MS = 5000;               /* anderes Fenster oder Seitenleiste offen, Tab im Hintergrund: später nochmals */
  var NOCHMAL_MAX = 12;                /* höchstens eine Minute warten, dann auf dieser Seite nicht mehr */
  var CSS_WARTEN_MS = 8000;            /* Stylesheet lädt nicht (auch langsames Handy-Netz): ohne Fenster bleiben statt ungestaltet öffnen */
  var ANFRAGE_MS = 10000;              /* Klaviyo antwortet nicht: Fehlermeldung, Knopf wieder frei */
  var KLAVIYO_URL = "https://a.klaviyo.com/client/subscriptions?company_id=";
  var KLAVIYO_REVISION = "2025-01-15";
  var QUELLE = "VitaFresh Newsletter-Fenster (Theme)";
  var TEXT = {
    mail: "Bitte überprüfe Deine E-Mail-Adresse.",
    fehler: "Das hat leider nicht geklappt. Bitte versuche es nochmals.",
    laeuft: "Einen Moment …"
  };

  var logik = {
    /* merk: gelesener Merker oder null; kunde: Merker vfnl-kunde gesetzt; jetzt: ms */
    zeigen: function (merk, kunde, jetzt) {
      if (kunde) return false;
      if (!merk || typeof merk !== "object") return true;
      if (merk.dabei) return false;
      var seit = jetzt - Number(merk.zu);
      if (isFinite(seit) && seit >= 0 && seit < RUHE_MS) return false;
      return true;
    },
    /* Zeitpunkt auf dieser Seite (Pasci 21.10.2026). z: { seiten: Seitenaufrufe dieses Besuchs inkl. diesem (sessionStorage,
       fehlt = 0), typ: request.page_type, korb: Zeitpunkt des letzten «In den Warenkorb» oder null, jetzt: ms, handy, gescrollt }.
       "nie" = auf dieser Seite nicht, "korb" = später nochmals (Warenkorb-Ruhe), "scrollen" = am Handy erst nach dem Scrollen,
       "jetzt" = darf öffnen. */
    entscheiden: function (z) {
      z = z || {};
      var seiten = Number(z.seiten);
      if (!isFinite(seiten) || seiten < 2) return "nie";
      if (SEITEN.indexOf(String(z.typ)) < 0) return "nie";
      var seit = Number(z.jetzt) - Number(z.korb);
      if (z.korb != null && isFinite(seit) && seit >= 0 && seit < KORB_RUHE_MS) return "korb";
      if (z.handy && !z.gescrollt) return "scrollen";
      return "jetzt";
    },
    /* JSON aus localStorage, kaputt oder leer = kein Merker */
    merkLesen: function (text) {
      if (!text) return null;
      try { var m = JSON.parse(text); return m && typeof m === "object" ? m : null; } catch (e) { return null; }
    },
    mailOk: function (s) {
      s = String(s == null ? "" : s).trim();
      return s.length > 0 && s.length <= 254 && /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/.test(s);
    },
    /* Body für POST /client/subscriptions (JSON:API, Einwilligung E-Mail-Marketing) */
    anfrage: function (mail, liste) {
      return {
        data: {
          type: "subscription",
          attributes: {
            custom_source: QUELLE,
            profile: { data: { type: "profile", attributes: { email: String(mail).trim(), subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } } } }
          },
          relationships: { list: { data: { type: "list", id: liste } } }
        }
      };
    },
    RUHE_MS: RUHE_MS,
    VERZOEGERUNG_MS: VERZOEGERUNG_MS,
    KORB_RUHE_MS: KORB_RUHE_MS,
    GESCROLLT_PX: GESCROLLT_PX,
    SEITEN: SEITEN.slice()
  };

  if (typeof module === "object" && module.exports) { module.exports = logik; return; }

  var doc = root.document;
  if (!doc || root.VFNL_GELADEN) return;
  root.VFNL_GELADEN = true;

  var vorlage = doc.getElementById("vfnl-vorlage");
  if (!vorlage || !vorlage.content || typeof root.HTMLDialogElement !== "function") return;

  function speicher(art, schluessel, wert) {
    try {
      if (art === "lesen") return root.localStorage.getItem(schluessel);
      root.localStorage.setItem(schluessel, wert);
    } catch (e) { /* privat, gesperrt, voll: dann eben ohne Merker */ }
    return null;
  }
  function sitzung(schluessel, wert) {
    try {
      if (wert === undefined) return root.sessionStorage.getItem(schluessel);
      root.sessionStorage.setItem(schluessel, wert);
    } catch (e) { /* ohne sessionStorage: keine Zählung, also kein Fenster */ }
    return null;
  }
  function merk() { return logik.merkLesen(speicher("lesen", MERK)); }
  function darf() { return !welcomeCookie() && logik.zeigen(merk(), !!speicher("lesen", KUNDE), Date.now()); }

  var typ = vorlage.getAttribute("data-seite") || "";
  var korbZeit = null;
  var gescrollt = false;
  function handy() {
    return !!(root.matchMedia && root.matchMedia("(max-width: 749px), (hover: none) and (pointer: coarse)").matches);
  }
  function zeitpunkt() {
    var k = Number(sitzung(KORB));
    korbZeit = isFinite(k) && k > 0 ? k : null;
    return logik.entscheiden({ seiten: sitzung(ZAEHLER), typ: typ, korb: korbZeit, jetzt: Date.now(), handy: handy(), gescrollt: gescrollt });
  }

  if (!darf()) return;

  var dialog = null;
  var versuche = 0;
  var laeuft = false;          /* Anfrage unterwegs (Knopf bleibt fokussierbar: aria-disabled statt disabled) */
  var druckAufHintergrund = false;

  /* Nicht über ein anderes Fenster legen (Quick-View, Mini-Warenkorb, Filter- und Nährwert-Feld der Kollektion, Warenkorb-Fenster,
     Theme-Popup), nicht im Hintergrund-Tab aufgehen und niemandem beim Tippen (Suche, PLZ) den Fokus wegnehmen. */
  var ANDERE = "dialog[open], body.sidebar-opened, html.vfko-panel-offen, html.vfwk-pop-offen, modal-box.active";
  /* nur Felder, in die man tippt: Filter-Häkchen und Schieber der Kollektion behalten den Fokus nach dem Klick */
  var TIPPFELD = "textarea, select, [contenteditable], input:not([type=checkbox]):not([type=radio]):not([type=range]):not([type=button]):not([type=submit]):not([type=hidden])";
  function andereOffen() {
    var a = doc.activeElement;
    return doc.hidden || !!doc.querySelector(ANDERE) || !!(a && a.matches && a.matches(TIPPFELD));
  }

  /* Landingpage-Link /discount/WELCOME15 mit leerem Warenkorb: Shopify merkt den Code im Cookie (in cart.discount_applications
     steht er erst mit Ware). Liest sich das Cookie nicht, bleibt es beim Entscheid des Snippets. */
  function welcomeCookie() {
    return /(?:^|;\s*)discount_code=WELCOME15(?:;|$)/i.test(doc.cookie || "");
  }

  function cssLaden() {
    return new Promise(function (fertig, fehler) {
      var href = vorlage.getAttribute("data-css");
      if (!href) { fertig(); return; }
      var link = doc.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      var uhr = root.setTimeout(fehler, CSS_WARTEN_MS);
      link.onload = function () { root.clearTimeout(uhr); fertig(); };
      link.onerror = function () { root.clearTimeout(uhr); fehler(); };
      doc.head.appendChild(link);
    });
  }

  var wartetAufScroll = false;
  var korbUhr = null;
  function versuchen() {
    if (!darf()) return;                     /* in einem anderen Tab inzwischen geschlossen oder angemeldet */
    var plan = zeitpunkt();
    if (plan === "nie") return;
    if (plan === "korb") {                   /* gerade etwas in den Warenkorb gelegt: nach der Ruhe nochmals */
      if (korbUhr) root.clearTimeout(korbUhr);
      korbUhr = root.setTimeout(function () { korbUhr = null; versuchen(); }, Math.max(1000, korbZeit + KORB_RUHE_MS - Date.now() + 500));
      return;
    }
    if (plan === "scrollen") { wartetAufScroll = true; return; }
    if (andereOffen()) {
      if (++versuche <= NOCHMAL_MAX) root.setTimeout(versuchen, NOCHMAL_MS);
      return;
    }
    cssLaden().then(function () {
      if (!darf() || andereOffen() || zeitpunkt() !== "jetzt") return;
      oeffnen();
    }, function () { /* ohne Gestaltung lieber gar nicht */ });
  }

  function oeffnen() {
    doc.body.appendChild(vorlage.content.cloneNode(true));
    dialog = doc.body.querySelector("dialog.vfnl");
    if (!dialog) return;
    dialog.addEventListener("pointerdown", function (ev) { druckAufHintergrund = ev.target === dialog; });
    dialog.addEventListener("click", klick);
    dialog.addEventListener("cancel", function () { merkeZu(); });  /* Esc: der Browser schliesst selbst */
    dialog.addEventListener("close", aufraeumen);
    dialog.querySelector("form").addEventListener("submit", absenden);
    dialog.querySelector("#vfnl-mail").addEventListener("input", function (ev) {
      if (ev.target.hasAttribute("aria-invalid")) { ev.target.removeAttribute("aria-invalid"); status(""); }
    });
    dialog.showModal();
    var feld = dialog.querySelector("#vfnl-mail");
    if (feld && root.matchMedia && root.matchMedia("(hover: hover) and (pointer: fine)").matches) feld.focus(); /* am Handy keine Tastatur ungefragt */
  }

  function merkeZu() {
    var m = merk();
    if (m && m.dabei) return;
    speicher("schreiben", MERK, JSON.stringify({ zu: Date.now() }));
  }

  function schliessen() {
    merkeZu();
    if (dialog && dialog.open) dialog.close();
  }

  function klick(ev) {
    /* Klick auf den abgedunkelten Hintergrund; nicht, wenn nur eine Textauswahl im Feld ausserhalb losgelassen wurde */
    if (ev.target === dialog) { if (druckAufHintergrund) schliessen(); return; }
    var ziel = ev.target.closest ? ev.target.closest("[data-vfnl-zu]") : null;
    if (ziel) schliessen();
  }

  function aufraeumen() {
    if (dialog && dialog.parentNode) dialog.parentNode.removeChild(dialog);
    dialog = null;
  }

  function status(text, art) {
    var s = dialog && dialog.querySelector("#vfnl-status");
    if (!s) return;
    s.textContent = text || "";
    s.setAttribute("data-art", art || "");
  }

  function absenden(ev) {
    ev.preventDefault();
    var form = ev.currentTarget;
    var feld = form.querySelector("#vfnl-mail");
    var knopf = form.querySelector(".vfnl__los");
    var mail = feld.value.trim();
    if (form.querySelector(".vfnl__falle").value) { danke(); return; }  /* Bot (Feld für Menschen unsichtbar): so tun als ob, nichts senden */
    if (laeuft) return;
    if (!logik.mailOk(mail)) {
      feld.setAttribute("aria-invalid", "true");
      status(TEXT.mail, "fehler");
      feld.focus();
      return;
    }
    feld.removeAttribute("aria-invalid");
    laeuft = true;
    knopf.setAttribute("aria-disabled", "true");
    form.setAttribute("aria-busy", "true");
    status(TEXT.laeuft, "laeuft");
    var ctrl = typeof root.AbortController === "function" ? new root.AbortController() : null;
    var uhr = root.setTimeout(function () { if (ctrl) ctrl.abort(); }, ANFRAGE_MS);
    root.fetch(KLAVIYO_URL + encodeURIComponent(vorlage.getAttribute("data-firma")), {
      method: "POST",
      headers: { "Content-Type": "application/vnd.api+json", "Accept": "application/vnd.api+json", "revision": KLAVIYO_REVISION },
      body: JSON.stringify(logik.anfrage(mail, vorlage.getAttribute("data-liste"))),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error("Klaviyo " + r.status);
      danke();
    }).catch(function () {
      status(TEXT.fehler, "fehler");
    }).then(function () {
      root.clearTimeout(uhr);
      laeuft = false;
      knopf.removeAttribute("aria-disabled");
      form.removeAttribute("aria-busy");
    });
  }

  function danke() {
    speicher("schreiben", MERK, JSON.stringify({ dabei: 1 }));
    if (!dialog) return;
    status("");
    dialog.querySelector('[data-vfnl-schritt="anmelden"]').hidden = true;
    dialog.querySelector('[data-vfnl-schritt="danke"]').hidden = false;
    dialog.removeAttribute("aria-describedby");
    var titel = dialog.querySelector("[data-vfnl-danke]");
    dialog.setAttribute("aria-labelledby", "");
    if (titel) { titel.id = "vfnl-danke"; dialog.setAttribute("aria-labelledby", "vfnl-danke"); titel.focus(); }
  }

  function starten() {
    if (zeitpunkt() === "nie") return;       /* erster Aufruf des Besuchs oder Einkaufsseite: nicht einmal warten */
    /* «In den Warenkorb» merkt der Einzeiler im Snippet auf jeder Seite (sessionStorage «vfnl-korb»); hier nur lesen.
       Bewusst nicht cart-updated: das kommt auch ohne Kauf (Zurück-Navigation, Tab-Rückkehr). */
    root.addEventListener("scroll", function () {
      if (gescrollt || (root.scrollY || root.pageYOffset || 0) < GESCROLLT_PX) return;
      gescrollt = true;
      if (wartetAufScroll) { wartetAufScroll = false; root.setTimeout(versuchen, 1500); }
    }, { passive: true });
    root.setTimeout(versuchen, VERZOEGERUNG_MS);
  }

  /* Vorgeladene Seite (Speculation Rules): zählt und wartet erst, wenn sie wirklich angezeigt wird */
  if (doc.prerendering) doc.addEventListener("prerenderingchange", starten, { once: true });
  else starten();
})(typeof window !== "undefined" ? window : globalThis);
